import includes from 'lodash/includes';
import { createSelector } from 'reselect';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
/**
 * Select memberships in the organization
 */ export const organizationMemberships = createSelector(mainSelector, (state)=>state.organizationMemberships);
//----------------------------------------------------------------------------------------------------------------------
/**
 * Organization template fetching action
 */ export const isFetchOrganizationMembershipsInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS));
export const hasFetchOrganizationMembershipsErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Approve Membership action
 */ export const isApproveMembershipInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.APPROVE_MEMBERSHIP));
export const hasApproveMembershipErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.APPROVE_MEMBERSHIP));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Reject Membership action
 */ export const isRejectMembershipInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.REJECT_MEMBERSHIP));
export const hasRejectMembershipErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.REJECT_MEMBERSHIP));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Delete membership action
 */ export const isDeleteMembershipInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.DELETE_MEMBERSHIP));
export const hasDeleteMembershipErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.DELETE_MEMBERSHIP));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Create Invitation action
 */ export const isCreateInvitationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.CREATE_INVITATION));
export const hasCreateInvitationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.CREATE_INVITATION));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Cancel Invitation action
 */ export const isCancelInvitationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.CANCEL_INVITATION));
export const hasCancelInvitationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.CANCEL_INVITATION));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Resend Invitation action
 */ export const isResendInvitationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.RESEND_INVITATION));
export const hasResendInvitationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.RESEND_INVITATION));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Grant admin action
 */ export const isGrantAdminInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.GRANT_ADMIN));
export const hasGrantAdminErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.GRANT_ADMIN));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Revoke admin action
 */ export const isRevokeAdminInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.REVOKE_ADMIN));
export const hasRevokeAdminErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.REVOKE_ADMIN)); //----------------------------------------------------------------------------------------------------------------------
